import { ModulePlaceholder } from "@/components/modules/ModulePlaceholder";

const Agents = () => {
  return <ModulePlaceholder moduleKey="agents" />;
};

export default Agents;
